import { Phone, Mail, MapPin, Fuel } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#F5F3EF] py-14">
    <div className="mx-auto max-w-7xl px-5">
      <div className="grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-[#1F7A6B] text-white">
              <Fuel strokeWidth={2.5} className="h-5 w-5" />
            </span>
            <span className="font-heading text-xl">
              Fuel<span className="text-[#1F7A6B]">Hero</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs leading-relaxed text-[#171717]/60">
            Sydney's wrong-fuel rescue service. Don't stress — help is always on the way.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-lg text-[#171717]">Get in touch</h4>
          <ul className="mt-4 space-y-3">
            <li>
              <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 font-medium text-[#171717]/75 hover:text-[#1F7A6B] transition-colors" data-testid="footer-phone">
                <Phone strokeWidth={2} className="h-4 w-4" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href="mailto:rescue@fuelhero.com.au" className="flex items-center gap-2 font-medium text-[#171717]/75 hover:text-[#1F7A6B] transition-colors" data-testid="footer-email">
                <Mail strokeWidth={2} className="h-4 w-4" /> rescue@fuelhero.com.au
              </a>
            </li>
            <li className="flex items-center gap-2 font-medium text-[#171717]/75">
              <MapPin strokeWidth={2} className="h-4 w-4" /> Servicing all of Sydney, NSW
            </li>
          </ul>
        </div>

        <div className="md:text-right">
          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center gap-2 rounded-full bg-[#1F7A6B] px-6 py-3.5 font-semibold text-white hover:bg-[#185f54] transition-colors"
            data-testid="footer-call-button"
          >
            <Phone strokeWidth={2.5} className="h-4 w-4" /> Call for rescue
          </a>
          <p className="mt-4 text-sm font-medium text-[#171717]/55">
            24/7 · No fix, no fee · Fully insured
          </p>
        </div>
      </div>

      <div className="mt-10 flex flex-col items-center justify-between gap-2 border-t border-black/10 pt-6 text-sm text-[#171717]/50 sm:flex-row">
        <span>© {new Date().getFullYear()} Fuel Hero. All rights reserved.</span>
        <span>Sydney's wrong-fuel specialists.</span>
      </div>
    </div>
  </footer>
);
